// Never import any server-only code here, this is also used on the client side...
import type { TranslationsMap } from './types';

// German version of the translation file
export const translations: TranslationsMap = {
  emails: {
    footer: {
      kindRegards: 'Mit freundlichen Grüßen,',
      questionsOrProblems: 'Fragen oder Probleme?',
      contactUs: 'Kontaktieren Sie uns',
    },
    transportOrder: {
      confirm: 'Bestätigen',
      refuse: 'Ablehnen',
    },
    forgotPassword: {
      resetLink: 'Passwort zurücksetzen',
    },
    userInvite: {
      view: 'Einladung ansehen',
    },
    attachments: {
      quotation: 'Zitat {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Bestellung anzeigen',
    },
  },
  truckDocumentType: {
    Insurance: 'Versicherung',
    Examination: 'Untersuchung',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Lieferschein',
    weighSlip: 'Wiegeschein',
    palletNote: 'Palettenschein',
    annexII: 'Anhang II',
    t1Document: 'T1-Dokument',
    annexVII: 'Anhang VII',
    saleInvoice: 'Rechnung',
    transportOrder: 'Transportauftrag',
    orderConfirmation: 'Auftragsbestätigung',
    sustainabilityReport: 'Nachhaltigkeitsbericht',
    customerAttachment: 'Kundenanhang',
    planning: 'Planung',
    other: 'Andere',
  },
  documentRejection: {
    subject: 'Dokument abgelehnt für Auftrag {{orderNumber}}',
    intro:
      'Wir konnten das {{documentType}}-Dokument, das wir für Auftrag {{orderNumber}} erhalten haben, nicht freigeben. Gründe:',
    outro:
      'Bitte senden Sie ein korrigiertes Dokument über den üblichen Weg oder über das Carrier-Portal. Vielen Dank!',
    MissingSignature: 'Die Unterschrift des Empfängers fehlt auf dem CMR.',
    WrongCustomer: 'Der Kunde auf dem Dokument stimmt nicht mit dem Kunden dieses Auftrags überein.',
    WrongOrgOnDocument: 'Der Spediteur/Absender auf dem Dokument stimmt nicht mit unserer Organisation überein.',
    NoOrderReference:
      'Wir konnten keine gültige Auftrags- oder Rechnungsreferenz finden, um das Dokument einem Auftrag zuzuordnen.',
    WrongDocumentType: 'Der Dokumenttyp entspricht nicht dem, was wir für diesen Auftrag erwarten.',
    LowQuality:
      'Die Scan-/Fotoqualität ist zu niedrig, um den Inhalt zuverlässig zu validieren. Bitte senden Sie eine bessere Qualität.',
  },
  trailerTypes: {
    BoxTrailer: 'Kofferanhänger',
    FlatBed: 'Flachbett',
    Mega: 'Mega-Anhänger',
    Refrigerated: 'Kühlanhänger',
    RoadTrain: 'Straßenzug',
    Tautliner: 'Tautliner',
    Joloda: 'Tautliner / Joloda',
    TautlinerCoil: 'Tautliner / Coil',
  },
  loadingMethods: {
    Back: 'Hinten',
    Side: 'Seite',
    Top: 'Über das Dach',
  },
  documents: {
    note: {
      extraInformation: 'Zusätzliche Informationen',
    },
    letter: {
      letter: 'Brief',
    },
    paymentReminder: {
      invoiceNumber: 'Rechnungsnummer',
      invoiceDate: 'Rechnungsdatum',
      dueDate: 'Fälligkeitsdatum',
      amount: 'Betrag',
      expiredAmount: 'Überfälliger Betrag',
      currency: 'Währung',
      totalOutstanding: 'Gesamt offen',
      salutation: 'Sehr geehrte Damen und Herren,',
      subject: {
        first: 'Betreff: Zahlungserinnerung — {{reference}}',
        second: 'Betreff: zweite Zahlungserinnerung — {{reference}}',
        third: 'Betreff: dritte Zahlungserinnerung — {{reference}}',
        final: 'Betreff: Inverzugsetzung — {{reference}}',
      },
      intro: {
        first:
          'Nach unseren Unterlagen sind die unten aufgeführten Rechnungen noch nicht beglichen. Sollte sich Ihre Zahlung mit diesem Schreiben überschnitten haben, betrachten Sie es bitte als gegenstandslos.',
        second:
          'Trotz unserer vorherigen Erinnerung haben wir für die unten aufgeführten Rechnungen noch keine Zahlung erhalten:',
        third: 'Trotz wiederholter Erinnerungen sind die unten aufgeführten Rechnungen weiterhin offen:',
        final:
          'Trotz früherer Zahlungserinnerungen haben wir bis heute keine Zahlung für die unten aufgeführten Rechnungen erhalten:',
      },
      request:
        'Wir bitten Sie, den offenen Betrag von {{amount}} innerhalb von {{days}} Kalendertagen nach Erhalt dieses Schreibens unter Angabe der Referenz auf das untenstehende Konto zu überweisen:',
      acknowledgement: 'Wenn Sie nicht zahlen und dafür keinen Grund angeben, gilt dies als Anerkennung der Forderung.',
      escalation: {
        first:
          'Sollten wir Ihre Zahlung nicht innerhalb dieser Frist erhalten, senden wir Ihnen eine weitere Erinnerung.',
        second: 'Sollten wir Ihre Zahlung nicht innerhalb dieser Frist erhalten, müssen wir diesen Vorgang eskalieren.',
        third: 'Erfolgt innerhalb dieser Frist keine Zahlung, wird dieser Vorgang an unser Inkassoverfahren übergeben.',
        final:
          'Erfolgt innerhalb dieser Frist keine Zahlung, geben wir diesen Vorgang ohne weitere Ankündigung an unseren Rechtsbeistand ab, mit der Anweisung, ein Gerichtsverfahren gegen Sie einzuleiten. Die Kosten gehen vollständig zu Ihren Lasten.',
      },
      closing: {
        first: 'Wir vertrauen darauf, dass Sie den offenen Betrag innerhalb der genannten Frist begleichen.',
        second: 'Wir vertrauen darauf, dass Sie den offenen Betrag innerhalb der genannten Frist begleichen.',
        third: 'Wir vertrauen darauf, dass Sie den offenen Betrag innerhalb der genannten Frist begleichen.',
        final:
          'Wir vertrauen darauf, dass dies nicht erforderlich sein wird und Sie den offenen Betrag innerhalb der genannten Frist begleichen.',
      },
      sincerely: 'Mit freundlichen Grüßen,',
      signature: 'Buchhaltung {{company}}',
      account: 'Konto {{company}}',
      accounts: 'Konten {{company}}',
      reference: 'Verwendungszweck',
      amountDue: 'Zu zahlender Betrag',
      bic: 'BIC',
      heldBy: 'Inhaber {{company}}',
      date: 'Datum',
      ourReference: 'Unsere Referenz',
      customerNumber: 'Kundennummer',
      yourVatNumber: 'Ihre USt-IdNr.',
      contact: 'Kontakt',
      phone: 'Telefon',
    },
    transportOrder: {
      trailerTypes: 'Anhängertypen',
      loadingMethod: 'Beladungsart',
      transportOrder: 'Transportauftrag',
      date: 'Datum',
      orderRef: 'Referenz der Bestellung',
      load: 'Laden',
      unload: 'Entladen',
      reference: 'Referenz',
      goods: 'Güter',
      description: 'Beschreibung',
      packageType: 'Palletentyp',
      palletCount: 'Paletten',
      weight: 'Gewicht',
      LoadingMeter: 'Lademeter',
      freightRate: 'Frachttarif',
      price: 'Preis',
      vat: 'MwSt',
      questionsOrComments: 'Fragen oder Anmerkungen?',
      contactFileManager: 'Zögern Sie nicht, Ihren Dateimanager zu kontaktieren',
      anonymousCmr: 'FÜR DIESE BESTELLUNG MUSS EIN ANONYMER CMR ERSTELLT WERDEN.',
      phone: 'Telefon',
      email: 'E-mail',
    },
    planning: {
      planning: 'Planung',
      licensePlate: 'Kennzeichen',
      codeName: 'Codename',
    },
    kilometers: {
      full: 'Lastkilometer',
      empty: 'Leerkilometer',
      total: 'Gesamtkilometer',
      planningTotal: 'Gesamt dieser Planung',
    },
    quotation: {
      quotation: 'Zitat',
      customerNumber: 'Kundennummer',
      reference: 'Referenz',
      date: 'Angebotsdatum',
      dueDate: 'Verfallsdatum',
      from: 'Von',
      to: 'Zu',
      volume: 'Volumen',
      price: 'Preis',
      generalTermsAndConditions: 'Allgemeine Geschäftsbedingungen im Anhang',
      questionsOrComments: 'Bei Fragen kontaktieren Sie uns bitte unter {{email}}',
      trailerTypes: 'Anhängertypen',
    },
    orderConfirmation: {
      orderConfirmation: 'Bestellbestätigung',
      dearCustomer: 'Sehr geehrter Kunde,',
      herebyWeConfirmYourOrder: 'Hiermit bestätigen wir Ihre Bestellung für die folgende Lieferung:',
      date: 'Datum',
      ourReference: 'Unsere Referenz',
      yourReference: 'Ihre Referenz',
      load: 'Laden',
      unload: 'Entladen',
      reference: 'Referenz',
      goods: 'Güter',
      description: 'Beschreibung',
      packageType: 'Palletentyp',
      palletCount: 'Paletten',
      weight: 'Gewicht',
      LoadingMeter: 'Lademeter',
      freightRate: 'Frachttarif',
      price: 'Preis',
      vat: 'MwSt',
      questionsOrComments: 'Fragen oder Anmerkungen?',
      contactFileManager: 'Zögern Sie nicht, Ihren Dateimanager zu kontaktieren',
      phone: 'Telefon',
      email: 'E-mail',
    },
    orderCancellation: {
      orderCancellation: 'Stornierung der Bestellung',
      dearCustomer: 'Sehr geehrter Kunde,',
      orderCancelledText: 'Ihre Bestellung für den unten aufgeführten Transport wurde hiermit storniert:',
      date: 'Datum',
      ourReference: 'Unsere Referenz',
      yourReference: 'Ihre Referenz',
      load: 'Laden',
      unload: 'Entladen',
      reference: 'Referenz',
      goods: 'Güter',
      description: 'Beschreibung',
      packageType: 'Palletentyp',
      palletCount: 'Paletten',
      weight: 'Gewicht',
      LoadingMeter: 'Lademeter',
      freightRate: 'Frachttarif',
      price: 'Preis',
      vat: 'MwSt',
      questionsOrComments: 'Fragen oder Anmerkungen?',
      contactFileManager: 'Zögern Sie nicht, Ihren Dateimanager zu kontaktieren',
      phone: 'Telefon',
      email: 'E-mail',
    },
    invoice: {
      invoice: 'Rechnung',
      customerNumber: 'Kundennummer',
      invoiceNumber: 'Rechnungsnummer',
      invoiceDate: 'Rechnungsdatum',
      dueDate: 'Fälligkeitsdatum',
      load: 'Laden',
      unload: 'Entladen',
      ourReference: 'Unsere Referenz',
      yourReference: 'Ihre Referenz',
      description: 'Beschreibung',
      quantity: 'Menge',
      unitPrice: 'Einzelpreis',
      total: 'Gesamt',
      vat: 'MwSt',
      paymentInformation: 'Zahlungsinformationen',
      amountToPay: 'Zu zahlender Betrag',
      toBePaidBefore: 'Vorher zu bezahlen',
      beneficiary: 'Begünstigter',
      message: 'Mitteilung',
      generalTermsAndConditions: 'Allgemeine Geschäftsbedingungen im Anhang',
      questionsOrComments: 'Bei Fragen wenden Sie sich bitte an die Buchhaltung unter {{email}}',
    },
    sustainabilityReport: {
      sustainabilityReport: 'Nachhaltigkeitsbericht',
      date: 'Datum',
      ourReference: 'Unsere Referenz',
      yourReference: 'Ihre Referenz',
      truck: 'Truck',
      distance: 'Entfernung',
      weight: 'Gewicht',
      emissions: 'Emissionen',
      questionsOrComments: 'Fragen oder Anmerkungen?',
      contactFileManager: 'Zögern Sie nicht, Ihren Dateimanager zu kontaktieren',
      phone: 'Telefon',
      email: 'E-mail',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Nachhaltigkeitsbericht',
      date: 'Datum',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      orderCount: 'Anzahl Bestellungen',
      truck: 'Lastwagen',
      totals: 'Gesamt',
      distance: 'Entfernung',
      weight: 'Gewicht',
      emissions: 'CO2-Emissionen',
      averagePerOrder: 'Durchschnitt pro Bestellung',
      framework:
        'Einzelheiten zur Emissionsberechnung finden Sie in der Nachhaltigkeitsrichtlinie auf unserer Website.',
      questionsOrComments: 'Fragen oder Anmerkungen?',
      contactFileManager: 'Kontaktieren Sie gerne Ihren Sachbearbeiter',
      phone: 'Tel.',
      email: 'E-Mail',
    },
    rideOverview: {
      title: 'Übersicht',
      entryNumber: 'Übersichtsreferenz',
      dossier: 'Akte',
      draftBanner: 'Entwurf — noch nicht genehmigt',
      invoiceRequestNotice:
        'Dieses Dokument ist keine gültige Self-Billing-Rechnung. Nach Erhalt dieser Übersicht erwartet {{customer}} von Ihnen eine Rechnung für diese Aufträge.',
    },
    selfBill: {
      title: 'Self-Billing-Rechnung',
      number: 'Nr.',
      draftBanner: 'Entwurf — noch nicht genehmigt',
      supplierLabel: 'Lieferant — Frachtführer · wir bezahlen dieses Unternehmen',
      customerLabel: 'Kunde — erstellt diese Rechnung im Namen des Lieferanten',
      vatCompanyNumber: 'USt-IdNr. / Unternehmensnr.:',
      vatShort: 'USt-IdNr.',
      carrierNumber: 'Frachtführernummer: {{number}}',
      customerRegister: 'RPR Gent, Abteilung Kortrijk',
      bankLabel: 'Zahlung auf das Bankkonto des Lieferanten',
      bankNotice:
        'In unserer Frachtführerdatei hinterlegt. Ist dies nicht Ihr Konto, wenden Sie sich bitte umgehend an {{email}}. Bankdaten werden nur über unser Prüfverfahren geändert, niemals aufgrund einer E-Mail-Anfrage.',
      documentType: 'Dokumentart',
      invoiceNumber: 'Rechnungsnummer',
      invoiceDate: 'Rechnungsdatum',
      servicePeriod: 'Leistungszeitraum',
      agreement: 'Vereinbarung',
      paymentDate: 'Zahlungsdatum',
      natureOfServices:
        'Art der Leistungen: {{nature}}, eine Fahrt pro Zeile, durchgeführt am angegebenen Versanddatum. Einzelpreis = Zeilenbetrag (Menge 1), ohne USt.',
      roadFreightTransport: 'Güterkraftverkehr',
      columnNumber: 'Nr.',
      columnFile: 'Auftrag',
      columnShipmentDate: 'Versanddatum',
      columnLoading: 'Beladung',
      columnUnloading: 'Entladung',
      columnQuantity: 'Anz.',
      columnVat: 'USt',
      columnAmount: 'EUR',
      tripCountOne: '1 Fahrt auf dieser Rechnung',
      tripCountOther: '{{count}} Fahrten auf dieser Rechnung',
      totalServices: 'Summe Transportleistungen (ohne USt)',
      earlyPaymentDiscount: 'Skonto {{percentage}}',
      earlyPaymentCondition:
        'Bei Zahlung innerhalb von 7 Tagen wird ein Skonto von {{percentage}} ({{amount}}) abgezogen. Zu zahlen: {{withDiscount}}. Nach Ablauf dieser Frist: {{withoutDiscount}}.',
      taxableAmount: 'Bemessungsgrundlage {{rate}}',
      vat: 'USt {{rate}}',
      totalToPay: 'Zu zahlender Betrag',
      paymentNotice:
        '{{amount}} werden am {{date}} automatisch auf {{iban}} überwiesen. Sie müssen nichts unternehmen.',
      paymentNoticeWithoutAccount:
        '{{amount}} werden am {{date}} automatisch überwiesen. Sie müssen nichts unternehmen.',
      yourInvoiceTitle: 'Dies ist Ihre Rechnung. Bitte senden Sie uns keine Rechnung für diese Fahrten.',
      yourInvoice:
        'Dieses Dokument wird von {{customer}} im Namen und für Rechnung von {{supplier}} auf Grundlage der Self-Billing-Vereinbarung zwischen beiden Parteien ausgestellt. Es ist kein Vorschlag. Eine Rechnung, die Sie selbst für dieselben Fahrten senden, wird als Duplikat abgelehnt.',
      acceptanceTitle: 'Annahme',
      acceptance:
        'Diese Rechnung gilt als vom Lieferanten angenommen, sofern ihr nicht innerhalb von 7 Tagen nach dem Rechnungsdatum schriftlich unter {{email}} widersprochen wird. Korrekturen erfolgen über eine Korrekturgutschrift.',
      paymentTermTitle: 'Zahlungsfrist',
      paymentTerm:
        'Es gilt die in Ihrem Vertrag vereinbarte Zahlungsfrist. Wurde Skonto gewährt, beträgt die Zahlungsfrist 7 Tage.',
      missingTripTitle: 'Fehlt eine Fahrt?',
      missingTrip:
        'Eine Fahrt fehlt auf dieser Rechnung, weil ihre Dokumente nicht in Ordnung sind. Laden Sie die richtigen Dokumente im Carrier-Portal hoch, dann erscheint die Fahrt auf Ihrer nächsten Self-Billing-Rechnung.',
      questionsTitle: 'Fragen?',
      questions: 'Wenden Sie sich unter Angabe der Rechnungsnummer an {{email}}.',
      legalSelfBilling: 'Gutschrift',
      legalNotice:
        '{{selfBilling}} — Rechnung ausgestellt vom Leistungsempfänger im Namen und für Rechnung des Lieferanten (Art. 224 und 226 Nr. 10a Richtlinie 2006/112/EG) · Self-Billing-Vereinbarung {{agreement}} · Peppol BIS Self-Billing 3.0, Dokumentart 389',
      legalTerms:
        'Allgemeine Verkaufsbedingungen beigefügt und verfügbar auf {{website}} · Es gilt belgisches Recht · Gerichtsstand Kortrijk',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: 'Seite {{page}} von {{total}}',
    },
    creditNote: {
      creditNote: 'Gutschrift',
      customerNumber: 'Kundennummer',
      creditNoteNumber: 'Gutschriftsnummer',
      date: 'Datum',
      dueDate: 'Fälligkeitsdatum',
      load: 'Laden',
      unload: 'Entladen',
      ourReference: 'Unsere Referenz',
      yourReference: 'Ihre Referenz',
      description: 'Beschreibung',
      quantity: 'Menge',
      unitPrice: 'Einzelpreis',
      total: 'Gesamt',
      vat: 'MwSt',
      paymentInformation: 'Zahlungsinformationen',
      amountToPay: 'Zu zahlender Betrag',
      toBePaidBefore: 'Vorher zu bezahlen',
      payer: 'Zahler',
      message: 'Mitteilung',
      generalTermsAndConditions: 'Allgemeine Geschäftsbedingungen im Anhang',
      questionsOrComments: 'Bei Fragen wenden Sie sich bitte an die Buchhaltung unter {{email}}',
    },
    carrierTruckReport: {
      title: 'LKW-Leistungsbericht',
      truckname: 'Name',
      totalIncome: 'Gesamteinkommen',
      totalKm: 'Gesamtkilometer',
    },
    totals: {
      totalExclVat: 'Gesamt exkl. MwSt',
      totalVat: 'Gesamt MwSt',
      totalInclVat: 'Gesamt inkl. MwSt',
      cashDiscount: 'Skonto',
      netAmountToPay: 'Nettobetrag zu zahlen',
      vatReverseCharged: 'VAT Reverse Charge, article 44 VAT Directive',
    },
  },
  carrierTerms: {
    agreement: 'Ich akzeptiere die {{terms}}, einschließlich des Self-Billing-Verfahrens.',
    termsLink: 'Allgemeinen Geschäftsbedingungen',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'Bestellung wurde abgelehnt',
      headingCancelled: 'Bestellung wurde storniert',
      headingConfirmed: 'Bestellung wurde bestätigt',
      headingUnknownStatus: 'Auftrag wurde bereits ausgeführt oder Status unbekannt',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'Die Terminvereinbarung wurde abgelehnt',
      headingCancelled: 'Der Zeitplan wurde abgesagt',
      headingConfirmed: 'Der Zeitplan wurde bestätigt',
      headingUnknownStatus: 'Die Planung wurde bereits durchgeführt oder der Status ist unbekannt',
    },
    confirmOrder: {
      heading: 'Transportauftrag bestätigen {{order.orderNumber}}',
      orderConfirmed: 'Bestellung bestätigt',
      orderConfirmationError: 'Bestellung konnte nicht bestätigt werden: {{error}}',
      confirmButton: `Transportauftrag bestätigen`,
    },
    confirmPlanning: {
      heading: 'Bestätigen Sie den Zeitplan {{planningDate}}',
      planningConfirmed: 'Zeitplan bestätigt',
      confirmButton: `Bestätigen Sie den Zeitplan`,
    },
    refuseOrder: {
      heading: 'Transportauftrag verweigern {{order.orderNumber}}',
      orderRefused: 'Bestellung abgelehnt',
      orderRefusalError: 'Bestellung konnte nicht abgelehnt werden: {{error}}',
      refuseButton: `Transportauftrag verweigern`,
    },
    refusePlanning: {
      heading: 'Abfallplanung {{planningDate}}',
      planningRefused: 'Terminplanung abgelehnt',
      refuseButton: 'Abfallplanung',
    },
    orderSummary: {
      loadAndUnloadInformation: 'Informationen zum Laden und Entladen',
      load: 'Laden',
      unload: 'Entladen',
      freightRate: 'Frachttarif',
      total: 'Gesamt',
    },
  },
  customerPortal: {
    switch: 'Kunde wechseln',
    selectCustomer: 'Kunde auswählen',
    requestAccount: {
      title: 'Konto anfordern',
      success: 'Anfrage wurde gesendet, wir werden Sie für weitere Schritte kontaktieren.',
      failed: 'Konto konnte nicht angefordert werden: {{error}}',
      name: 'Name',
      email: 'E-Mail',
      companyName: 'Firmenname',
      companyNumber: 'Firmennummer',
      request: 'Anfordern',
      dontHaveAnAccount: 'Sie haben noch kein Konto?',
    },
    invite: {
      title: 'Einladung zum Kundenportal',
      details:
        'Sie wurden zum Kundenportal von TransDirect eingeladen, erstellen Sie Ihr Konto, indem Sie Ihr Passwort eingeben.',
      accepted: 'Einladung wurde akzeptiert, Sie werden in Kürze zur Startseite weitergeleitet.',
      acceptError: 'Einladung konnte nicht angenommen werden: {{error}}',
      acceptButtonText: 'Einladung annehmen',
      password: 'Passwort',
      repeatPassword: 'Passwort wiederholen',
    },
    home: {
      customerPortal: 'Kundenportal',
      title: 'Kundenportal von {{customerName}}',
      hello: 'Hallo,',
      welcome: 'Willkommen im Kundenportal.',
      manageOrders: 'Verwalten Sie alle Ihre Transportaufträge.',
      viewInvoices: 'Rechnungen einfach einsehen und bezahlen.',
      createQuotes: 'Angebote erstellen und verfolgen.',
      viewLocations: 'Alle Transportstandorte anzeigen.',
    },
    locations: {
      locations: 'Orte',
      location: 'Standort',
      name: 'Name',
      street: 'Straße',
      number: 'Nummer',
      countryCode: 'Ländercode',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
      language: 'Sprache',
      notes: 'Notizen',
      createLocation: 'Ort erstellen',
      newLocation: 'Neuer Ort',
      locationCreated: 'Ort erstellt',
      couldNotCreateLocation: 'Ort konnte nicht erstellt werden: {{error}}',
      findLocation: 'Ort suchen...',
      address: 'Adresse',
      locationNotFound: 'Ort nicht gefunden',
      couldNotLoadLocation: 'Ort konnte nicht geladen werden: {{error}}',
    },
    order: {
      duplicate: 'Duplizieren',
      bulkDuplicate: 'Massenduplizierung',
      bulkDuplicateTitle: 'Bestellung massenhaft duplizieren',
      bulkDuplicateDescription: 'Erstellen Sie mehrere Kopien dieser Bestellung mit aufsteigenden Rechnungsreferenzen.',
      numberOfDuplicates: 'Anzahl der Duplikate',
      baseInvoiceRef: 'Start-Rechnungsreferenz',
      baseInvoiceRefHelper:
        'Numerische Basis. Führende Nullen werden entfernt. Referenzen werden Basis bis Basis+Anzahl-1.',
      skipDraft: 'Entwurfsstatus überspringen (direkt als Erstellt)',
      bulkDuplicateSuccess: '{{count}} Bestellungen erstellt',
      bulkDuplicateError: 'Bestellungen konnten nicht dupliziert werden: {{error}}',
      referencePreview: 'Referenzen: {{first}} bis {{last}}',
      overview: 'Übersicht',
      updateInvoiceRef: 'Rechnungsreferenz aktualisieren',
      updated: 'Bestellung wurde aktualisiert',
      couldNotUpdate: 'Bestellung konnte nicht aktualisiert werden: {{error}}',
    },
    orders: {
      orders: 'Bestellungen',
      placeOrder: 'Bestellung aufgeben',
      invoiceRef: 'Rechnungsreferenz',
      orderRef: 'Auftragsreferenz',
      loadLocation: 'Ladeort',
      unloadLocation: 'Entladeort',
      loadDate: 'Ladedatum',
      loadTime: 'Ladezeit',
      unloadDate: 'Entladedatum',
      unloadTime: 'Entladezeit',
      invoiceTotal: 'Rechnungsbetrag',
      status: 'Status',
      invoiceStatus: 'Rechnungsstatus',
      hasCMR: 'Hat CMR',
      creationDate: 'Erstellungsdatum',
      executionDate: 'Ausführungsdatum',
      fileManager: 'Dateimanager',
      cancellationReason: 'Stornierungsgrund',
      stops: 'Stopps',
      deleteStop: 'Stopp löschen',
      purchases: 'Einkäufe',
      total: 'Gesamt',
      trailerTypes: 'Anhängertypen',
      loadingMethod: 'Beladungsart',
      load: 'Laden',
      unload: 'Entladen',
      typeStop: 'Stopptyp',
      extraNotes: 'Zusätzliche Notizen',
      noContent: 'Kein Inhalt',
      packaging: 'Verpackung',
      coli: 'Coli',
      content: 'Inhalt',
      addContent: 'Inhalt hinzufügen',
      deleteContent: 'Inhalt löschen',
      noStops: 'Keine Stopps',
      noStopsError: 'Fügen Sie mindestens einen Be- und Entladehalt hinzu',
      reference: 'Referenz',
      complaints: 'Beschwerden',
      fileComplaint: 'Beschwerde melden',
      fileComplaintDescription: 'Füllen Sie dieses Formular aus, um eine Beschwerde melden',
      send: 'Senden',
      reason: 'Grund',
      details: 'Details',
      complaintFiled: 'Beschwerde eingereicht',
      couldNotFileComplaint: 'Konnte Beschwerde nicht einreichen: {{error}}',
      placeAnOrder: 'Bestellung aufgeben',
      assignment: 'Auftrag',
      addStop: 'Stopp hinzufügen',
      location: 'Standort',
      date: 'Datum',
      start: 'Start',
      stop: 'Stopp',
      weight: 'Gewicht (kg)',
      volume: 'Volumen (m3)',
      loadMeter: 'Lademeter',
      stopsRequired: 'Mindestens 1 Stopp ist erforderlich',
      contentRequired: 'Mindestens 1 Inhaltselement ist erforderlich',
      truck: 'Truck',
      distance: 'Entfernung',
      emissions: 'Emissionen',
      sustainability: 'Nachhaltigkeit',
      attachments: 'Anhänge',
      uploadAttachments: 'Anhänge hochladen',
      attachmentDeleted: 'Anhang gelöscht',
      couldNotDeleteAttachment: 'Anhang konnte nicht gelöscht werden: {{error}}',
      uploadedAttachment: 'Anhang {{document}} hochgeladen',
      uploadFailed: 'Anhang {{document}} konnte nicht hochgeladen werden: {{error}}',
      route: 'Route',
      chooseMethod: 'Methode wählen',
      automatic: 'Automatisch',
      automaticDescription:
        'Laden Sie ein oder mehrere Transportauftrags-PDFs hoch und unsere KI extrahiert die Auftragsdetails automatisch. Jedes PDF wird zu einem separaten Auftrag.',
      manual: 'Manuell',
      manualDescription: 'Füllen Sie das Auftragsformular selbst aus mit allen Stopps, Fracht- und Lieferdetails.',
      uploadPdfs: 'Transportauftrags-PDFs hochladen',
      processingPdf: 'PDF wird verarbeitet...',
      createOrders: 'Aufträge erstellen',
      orderCreated: 'Auftrag erstellt',
      ordersCreated: '{{count}} Aufträge erstellt',
      couldNotCreateFromPdf: 'Auftrag konnte nicht aus PDF erstellt werden: {{error}}',
      uploadAtLeastOnePdf: 'Laden Sie mindestens ein PDF hoch',
      viewOrder: 'Auftrag anzeigen',
      creatingOrders: 'Aufträge werden erstellt...',
      report: 'Bericht',
      orderPlaced: 'Auftrag erteilt',
      couldNotPlaceOrder: 'Auftrag konnte nicht erteilt werden: {{error}}',
      stopNumber: 'Stopp {{number}} - {{type}}',
      orderLink: 'Auftrag {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Angebote',
      quote: 'Angebot',
      quoteReference: 'Angebotsreferenz',
      quoteDate: 'Angebotsdatum',
      expirationDate: 'Verfallsdatum',
      total: 'Gesamt',
      search: 'Suche nach einem Angebot...',
      quotation: 'Angebot {{reference}}',
      notFound: 'Angebot nicht gefunden',
      departurePlace: 'Abfahrtsort',
      destination: 'Ziel',
      distance: 'Entfernung',
      price: 'Preis',
      type: 'Type',
      requests: 'Angebote anfordern',
      request: 'Angebot anfordern',
      notes: 'Notizen',
      lines: 'Angebotszeilen',
      addLine: 'Zeile hinzufügen',
      noLines: 'Keine Angebotszeilen',
      requestTitle: 'Angebot anfordern für {{reference}}',
      requestSuccess: 'Angebot angefordert',
      requestFailed: 'Angebot konnte nicht angefordert werden: {{error}}',
      quotationRequests: 'Angebotsanfragen',
      hasQuote: 'Hat Angebot',
      requestedAt: 'Angefordert am',
      generalInformation: 'Allgemeine Informationen',
      removeLine: 'Zeile entfer nen',
    },
    quoteLine: {
      from: 'Von',
      to: 'Nach',
    },
    invoices: {
      invoices: 'Rechnungen',
      invoiceNumber: 'Rechnungsnummer',
      invoiceDate: 'Rechnungsdatum',
      dueDate: 'Fälligkeitsdatum',
      total: 'Gesamt',
      search: 'Suche nach einer Rechnung...',
      notFound: 'Rechnung nicht gefunden',
      invoice: 'Rechnung {{invoiceNumber}}',
      structuredComment: 'Strukturierter Kommentar',
      reference: 'Referenz',
      sentAt: 'Gesendet am',
      load: 'Beladung',
      unload: 'Entladung',
      description: 'Beschreibung',
      amount: 'Menge',
      unitPrice: 'Stückpreis',
      vat: 'MwSt',
      extraInformation: 'Zusatzinformationen: {{extraInformation}}',
      orderTotal: 'Gesamtbestellwert: €{{total}}',
      totalExclVat: 'Gesamt ohne MwSt:',
      totalVat: 'MwSt gesamt:',
      totalInclVat: 'Gesamtbetrag inkl. MwSt:',
      generalInformation: 'Allgemeine Informationen',
    },
    creditNotes: {
      creditNotes: 'Gutschriften',
      creditNoteNumber: 'Gutschriftsnummer',
      creditNoteDate: 'Gutschriftsdatum',
      dueDate: 'Fälligkeitsdatum',
      total: 'Gesamt',
      search: 'Gutschrift suchen...',
      notFound: 'Gutschrift nicht gefunden',
      creditNote: 'Gutschrift {{creditNoteNumber}}',
      structuredComment: 'Strukturierte Mitteilung',
      reference: 'Referenz',
      sentAt: 'Gesendet am',
      load: 'Laden',
      unload: 'Entladen',
      description: 'Beschreibung',
      amount: 'Menge',
      unitPrice: 'Stückpreis',
      vat: 'MwSt.',
      extraInformation: 'Zusätzliche Informationen: {{extraInformation}}',
      orderTotal: 'Bestellsumme: €{{total}}',
      totalExclVat: 'Gesamtbetrag exkl. MwSt.:',
      totalVat: 'MwSt. Gesamt:',
      totalInclVat: 'Gesamtbetrag inkl. MwSt.:',
      generalInformation: 'Allgemeine Informationen',
    },
    businessInformation: {
      businessInformation: 'Unternehmensinformationen',
      updateBusinessInformation: 'Unternehmensinformationen aktualisieren',
      name: 'Name',
      vatNumber: 'Umsatzsteuer-Identifikationsnummer',
      businessNumber: 'Unternehmensnummer',
      saveChanges: 'Änderungen speichern',
      informationChanged: 'Informationen wurden aktualisiert',
      informationNotChanged: 'Informationen konnten nicht aktualisiert werden: {{error}}',
      requestChanges:
        'Um den Firmennamen, die USt-IdNr. oder die Handelsregisternummer zu aktualisieren, kontaktieren Sie uns bitte.',
    },
    ourInformation: {
      ourInformation: 'Firmendaten TransDirect',
      name: 'Name',
      vatNumber: 'Umsatzsteuer-ID',
      businessNumber: 'Handelsregisternummer',
      address: 'Adresse',
      contact: 'Kontakt',
      phoneNumber: 'Telefonnummer',
      emailTransport: 'Transport E-Mail',
      emailAccounting: 'Buchhaltung E-Mail',
      emailGeneral: 'Allgemeine E-Mail',
    },
    contacts: {
      contacts: 'Kontakte',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      function: 'Funktion',
      language: 'Sprache',
      notifications: 'Benachrichtigungen',
      newContact: 'Neuer Kontakt',
      contactCreated: 'Kontakt erstellt',
      couldNotCreateContact: 'Konnte Kontakt nicht erstellen: {{error}}',
      createContact: 'Kontakt erstellen',
      notFound: 'Kontakt nicht gefunden',
      updatedContact: 'Kontakt aktualisiert',
      couldNotUpdateContact: 'Konnte Kontakt nicht aktualisieren: {{error}}',
      updateContact: 'Kontakt aktualisieren',
      delete: 'Löschen',
      deleteContact: 'Kontakt löschen',
      deleteContactConfirmation: 'Sind Sie sicher, dass Sie den Kontakt {{name}} löschen möchten?',
      deleteContactError: 'Kontakt konnte nicht gelöscht werden: {{error}}',
      deleteContactSuccess: 'Kontakt gelöscht',
    },
    users: {
      users: 'Benutzer',
      inviteUser: 'Benutzer einladen',
      invitedUsers: 'Eingeladene Benutzer',
      noInvitedUsers: 'Keine eingeladenen Benutzer',
      removeInvite: 'Einladung entfernen',
      confirmRemoveInvite: 'Sind Sie sicher, dass Sie die Einladung für {{email}} entfernen möchten?',
      inviteRemoved: 'Einladung entfernt',
      couldNotRemoveInvite: 'Einladung konnte nicht entfernt werden: {{error}}',
      noUsersFound: 'Keine Benutzer gefunden',
      removeUser: 'Benutzer entfernen',
      confirmRemoveUser: 'Sind Sie sicher, dass Sie den Benutzer {{name}} entfernen möchten?',
      userRemoved: 'Benutzer entfernt',
      couldNotRemoveUser: 'Benutzer konnte nicht entfernt werden: {{error}}',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      userInvited: 'Benutzer eingeladen',
      couldNotInviteUser: 'Benutzer konnte nicht eingeladen werden: {{error}}',
      name: 'Name',
      email: 'E-Mail',
      isActive: 'Ist aktiv?',
      invited: 'Eingeladen',
    },
    cmrReminder: {
      cmrReminder: 'CMR Erinnerung',
      sendReminder: 'Senden',
      confirmText: 'Sind Sie sicher, dass Sie eine CMR Erinnerung senden möchten?',
      confirmation: 'CMR Erinnerung gesendet',
      error: 'Konnte CMR Erinnerung nicht senden: {{error}}',
    },
    sustainability: {
      sustainability: 'Nachhaltigkeit',
      policy: 'Nachhaltigkeitspolitik',
      viewOverview: 'Nachhaltigkeit ubersicht anzeigen',
      orderCount: 'Anzahl der Bestellungen',
      totalDistance: 'Gesamtstrecke',
      totalWeight: 'Gesamtgewicht',
      totalEmissions: 'Gesamte CO2-Emissionen',
      averageDistance: 'Durchschnittliche Entfernung',
      averageWeight: 'Durchschnittsgewicht',
      averageEmissions: 'Durchschnittliche Emissionen',
      total: 'Gesamt',
      avgPerOrder: 'Durchschnitt pro Bestellung',
    },
    settings: {
      settings: 'Einstellungen',
    },
    apiKeys: {
      apiKeys: 'API-Schlüssel',
      createApiKey: 'API-Schlüssel erstellen',
      name: 'Name',
      scopes: 'Berechtigungen',
      status: 'Status',
      lastUsed: 'Zuletzt verwendet',
      createdAt: 'Erstellt am',
      prefix: 'Präfix',
      active: 'Aktiv',
      revoked: 'Widerrufen',
      expired: 'Abgelaufen',
      never: 'Nie',
      revokeApiKey: 'API-Schlüssel widerrufen',
      confirmRevoke:
        'Möchten Sie den API-Schlüssel "{{name}}" wirklich widerrufen? Dies kann nicht rückgängig gemacht werden.',
      apiKeyRevoked: 'API-Schlüssel wurde widerrufen',
      couldNotRevoke: 'API-Schlüssel konnte nicht widerrufen werden: {{error}}',
      apiKeyCreated: 'API-Schlüssel wurde erstellt',
      couldNotCreate: 'API-Schlüssel konnte nicht erstellt werden: {{error}}',
      copyKey: 'Schlüssel kopieren',
      keyCopied: 'Schlüssel kopiert',
      keyWarning: 'Bewahren Sie diesen Schlüssel sicher auf. Er wird nicht erneut angezeigt.',
      noApiKeys: 'Keine API-Schlüssel gefunden',
      ordersRead: 'Bestellungen lesen',
      ordersWrite: 'Bestellungen erstellen',
      maxKeysReached: 'Maximale Anzahl an API-Schlüsseln erreicht',
      scopeRequired: 'Mindestens ein Geltungsbereich ist erforderlich',
    },
    loading: 'Laden...',
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Kundenkonto anfordern',
      requestCarrierAccount: 'Spediteurskonto anfordern',
      success: 'Anfrage wurde gesendet, wir werden Sie für weitere Schritte kontaktieren.',
      failed: 'Konto konnte nicht angefordert werden: {{error}}',
      name: 'Name',
      email: 'E-Mail',
      companyName: 'Firmenname',
      companyNumber: 'Firmennummer',
      request: 'Anfordern',
      dontHaveAnAccount: 'Sie haben noch kein Konto?',
      accountRequestFailed: 'Kontoanfrage fehlgeschlagen',
    },
  },
  liveTracking: {
    title: 'Tracking',
    subtitle: 'Standort und Bordcomputer dieses Lkw.',
    loading: 'Standort wird geladen…',
    noPosition: 'Für diesen Lkw ist noch kein Standort bekannt.',
    noPositionHint: 'Verknüpfen Sie auf der Integrationsseite ein Fahrzeug mit diesem Kennzeichen.',
    noConnection:
      'Diesem Lkw ist noch keine Tracking-Verbindung zugeordnet. Verbinden Sie eine, um den Standort zu sehen.',
    driving: 'Fährt',
    idle: 'Steht',
    location: 'Standort',
    speed: 'Geschwindigkeit',
    heading: 'Richtung',
    odometer: 'Kilometerstand',
    fuel: 'Kraftstoff',
    lastMeasurement: 'Letzte Messung',
    liveActive: 'Live-Tracking aktiv — Aktualisierung alle 30 Sekunden.',
    lastSignal: 'Letztes Signal',
    trailer: 'Auflieger',
    refresh: 'Aktualisieren',
    startLive: 'Live-Tracking starten',
    stopLive: 'Live-Tracking stoppen',
    resizePanel: 'Größe des Seitenbereichs ändern',
    connections: 'Tracking-Verbindungen',
    connectionsSubtitle: 'Verbinden Sie die Tracking-Umgebung eines Lieferanten, um dessen Lkw zu verfolgen.',
    addConnection: 'Tracking-Verbindung hinzufügen',
    integrations: 'Tracking-Integrationen',
    integrationsHint: 'Wählen Sie einen Anbieter, um das Tracking eines Lieferanten zu verbinden.',
    providerFleetmaster: 'Verfolgen Sie Standort und Bordcomputer der Lkw über FleetMaster.lt.',
    connectionLabel: 'Name',
    connectionLabelHelp: 'Wie diese Verbindung in der Liste erscheint.',
    helpCompanyId: 'Die Firmen-ID aus deinem FleetMaster-Telematik-Konto.',
    helpSuivoBaseUrl: 'Leer lassen für die Standard-Suivo-Umgebung.',
    ownerLabel: 'Lieferanten-ID',
    ownerHelp: 'Für eine Verbindung eines Charterers/Lieferanten.',
    credentialsNote: 'Der Schlüssel wird verschlüsselt gespeichert und nach dem Speichern nie wieder angezeigt.',
    connect: 'Verbinden',
    back: 'Zurück',
    noConnections: 'Noch keine Tracking-Verbindung.',
    noConnectionsHint: 'Fügen Sie eine hinzu, um die Standorte der Lkw zu sehen.',
    moreConnectionsTitle: 'Weitere Tracking-Verbindungen folgen in Kürze',
    moreConnectionsBody:
      'FleetMaster ist der erste Anbieter. Wir arbeiten an weiteren Tracking-Verbindungen — neue Anbieter erscheinen hier automatisch.',
    connectionsLoading: 'Verbindungen werden geladen…',
    vehiclesLoading: 'Fahrzeuge werden geladen…',
    noVehicles: 'Diese Verbindung meldet noch keine Fahrzeuge.',
    statusActive: 'Aktiv',
    statusError: 'Fehler',
    keyLabel: 'Schlüssel',
    linkedCount: '{{linked}} von {{total}} Fahrzeugen verknüpft',
    lastChecked: 'letzte Prüfung',
    never: 'nie',
    supplierOwner: 'Lieferant #{{id}}',
    connectionSettings: 'Verbindungseinstellungen',
    verify: 'Prüfen',
    verifyOk: 'Die Verbindung funktioniert.',
    verifyFailed: 'Die Verbindung konnte nicht geprüft werden.',
    remove: 'Löschen',
    removeTitle: 'Verbindung löschen',
    removeDescription: 'Die Verbindung "{{label}}" und der gespeicherte Schlüssel werden gelöscht.',
    connectionRemoved: 'Verbindung gelöscht.',
    linkVehicles: 'Fahrzeuge verknüpfen',
    linkVehiclesHint: 'Wähle ein Fahrzeug und dann den Lkw, in dem es fährt.',
    link: 'Verknüpfen',
    unlink: 'Trennen',
    linkTruck: 'Lkw verknüpfen',
    chooseTruck: 'Lkw',
    chooseTruckHelp: 'Wählen Sie den Lkw, in dem dieses Fahrzeug fährt.',
    chooseTruckRequired: 'Wählen Sie einen Lkw',
    moreTrucks: 'Es werden nur die ersten {{count}} Lkw angezeigt — suchen Sie, um die Liste einzugrenzen.',
    plateMatch: 'Kennzeichen stimmt überein',
    linkedTo: 'Verknüpft mit {{truck}}',
    linkedManually: 'manuell',
    notLinked: 'Nicht verknüpft',
    vehicleLinked: 'Fahrzeug verknüpft.',
    vehicleUnlinked: 'Verknüpfung entfernt.',
    trailerSubtitle: 'Standort dieses Aufliegers.',
    linkTracker: 'Tracker koppeln',
    linkTrackerHint: 'Wähle das Fahrzeug, das in diesem Auflieger steckt.',
    linkTrailer: 'Auflieger koppeln',
    linkTrailerHint: 'Wähle ein Fahrzeug und danach den Auflieger, auf dem es sitzt.',
    chooseTrailer: 'Auflieger',
    chooseTrailerRequired: 'Wähle einen Auflieger',
    noTrackerLinked: 'Mit diesem Auflieger ist noch kein Tracker verbunden — kopple einen, um den Standort zu sehen.',
    noTrailerPosition: 'Für diesen Auflieger ist noch kein Standort bekannt.',
    searchUnits: 'Nach Name oder Kennzeichen suchen…',
    noUnits: 'Noch keine Fahrzeuge gemeldet.',
    providerSuivo: 'Verfolge den Standort unserer Auflieger mit Suivo-Trackern.',
    ownerKindLabel: 'Eigentümer',
    ownerKindCompany: 'Eigene Flotte (Unternehmen)',
    ownerKindCarrier: 'Frachtführer/Lieferant',
    supplierOwnerCompany: 'Eigene Flotte',
    status: {
      moving: 'Fährt',
      parked: 'Geparkt',
      idling: 'Leerlauf',
      immobilized: 'Blockiert',
      offline: 'Kein Signal',
      inOperation: 'In Betrieb',
    },
    trailersMap: {
      searchLabel: 'Suche (TDR-ID / Name / Kennzeichen)',
      searchPlaceholder: 'Nach Name oder Kennzeichen suchen...',
      trackerLabel: 'Tracker',
      trackerAll: 'Alle Auflieger',
      trackerTracked: 'Mit Tracker',
      trackerUntracked: 'Ohne Tracker',
      trackerSilent: 'Kein Signal > 24 Std.',
      tableCardTitle: 'Auflieger',
      mapCardTitle: 'Karte',
      tableTrailer: 'Auflieger',
      tablePlate: 'Kennzeichen',
      tableTracker: 'Tracker',
      tableStatus: 'Status',
      tableLastSignal: 'Letztes Signal',
      tablePlace: 'Ort',
      noTracker: 'Kein Tracker',
      clearFilters: 'Alle Filter löschen',
      noneTrackedTitle: 'Noch kein Tracker verknüpft',
      noneTrackedDescription: 'Verknüpfen Sie eine Suivo-Einheit mit einem Auflieger, um ihn auf der Karte zu sehen.',
      noneInFilter: 'Keine Auflieger in dieser Auswahl',
      noConnectionsTitle: 'Noch keine Tracking-Verbindung',
      noConnectionsDescription: 'Fügen Sie eine Verbindung hinzu, um die Standorte unserer Auflieger zu sehen.',
      noConnectionsAction: 'Zu den Tracking-Integrationen',
      connectionErrorTitle: 'Tracking-Verbindung mit Fehler',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Tracking' },
    selectCarrier: 'Spediteur auswählen',
    loading: 'Laden...',
    switch: 'Spediteur wechseln',
    home: {
      carrierPortal: 'Carrier Portal',
      title: 'Carrier Portal',
      hello: 'Hallo,',
      welcome: 'Willkommen im Carrier Portal.',
      manageOrders: 'Verwalten Sie alle Ihre Transportaufträge.',
      managePlanning: 'Verwalten Sie Ihre Planung.',
      selfBilling: 'Erstellen und verwalten Sie Ihre Self-Billing-Rechnungen.',
      info: 'Information',
      infoSubtitle: 'Informationen über TransDirect & das Carrier Portal',
      contact: 'Ansprechpartner',
      contactSubtitle: 'Wer ist Ihr TransDirect-Ansprechpartner',
      FuelCard: 'Tankkarte',
      FuelCardSubtitle: 'Fordern Sie Ihre personalisierte TransDirect-Tankkarte an',
      saveChanges: 'Änderungen speichern',
    },
    orders: {
      allAccepted: 'Alle Aufträge bestätigt',
      customerReference: 'Kundenreferenz',
      draft: 'Entwurf',
      load: 'Beladung',
      orders: 'Aufträge',
      manageOrders: 'Verwalten Sie alle Ihre Transporte & laden Sie Ihre Transportdokumente hoch',
      orderRef: 'TD-Referenz',
      loadLocation: 'Ladeort',
      unload: 'Entladung',
      unloadLocation: 'Entladeort',
      invoiceTotal: 'Rechnungsbetrag',
      hasCMR: 'Hat Dokumente',
      documents: 'Dokumente',
      cmrRejected: 'Abgelehnt',
      cmrPending: 'In Bearbeitung',
      cmrUploadHint: 'Sie können eine oder mehrere PDF-Dateien hochladen; wir fassen diese zu einem Dokument zusammen.',
      cmrUploaded: 'Dokument hochgeladen',
      cmrUploadFailed: 'Dokument konnte nicht hochgeladen werden: {{error}}',
      documentValidation: 'Dokumente',
      documentValidationNoDocuments: 'Keine Dokumente',
      documentValidationPending: 'In Bearbeitung',
      documentValidationApproved: 'Genehmigt',
      documentValidationRejected: 'Abgelehnt',
      outstandingDocsTitle: 'Noch zu liefernde Dokumente',
      requiredDocMissing: 'fehlt',
      requiredDocInReview: 'in Bearbeitung',
      requiredDocRejected: 'abgelehnt — bitte erneut hochladen',
      requiredDocStatusReceived: 'Erhalten',
      requiredDocStatusInReview: 'In Prüfung',
      requiredDocStatusRejected: 'Abgelehnt',
      requiredDocStatusMissing: 'Fehlt',
      requiredDocsTitle: 'Erforderliche Dokumente',
      requiredDocsSubtitle: 'Dieser Kunde verlangt für diesen Auftrag die folgenden Dokumente.',
      requiredDocsProgress: '{{done}} von {{total}} erhalten',
      requiredDocReupload: 'Erneut hochladen',
      uploadDocumentTitle: '{{document}} hochladen',
      uploadRequiredDoc: 'Hochladen',
      uploadDocumentsTitle: 'Dokumente hochladen',
      uploadDocumentsHint:
        'Laden Sie eine oder mehrere Dateien auf einmal hoch; wir teilen sie auf und ordnen jeden Teil dem richtigen Dokumenttyp zu.',
      docReasonInReview: 'in Prüfung',
      docReasonRejected: 'abgelehnt',
      docRejectionLowQuality: 'unlesbar',
      docRejectionMissingSignature: 'Unterschrift fehlt',
      docRejectionNoOrderReference: 'keine Referenz gefunden',
      docRejectionNotNeutral: 'nicht neutraler CMR',
      docRejectionWrongCustomer: 'falscher Kunde',
      docRejectionWrongDeliveryAddress: 'falsche Lieferadresse',
      docRejectionWrongDocumentType: 'falscher Dokumenttyp',
      docRejectionWrongOrgOnDocument: 'falsches Unternehmen',
      requiredDocUploaded: 'Dokument hochgeladen',
      requiredDocUploadFailed: 'Dokument konnte nicht hochgeladen werden: {{error}}',
      purchases: 'Einkäufe',
      reference: 'Referenz',
      assignee: 'Zugewiesen an',
      orderAssigned: 'Auftrag zugewiesen',
      changeAssignee: 'Ändern',
      assignOrder: 'Auftrag zuweisen',
      assign: 'Zuweisen',
      route: 'Route',
      error: 'Fehler',
      report: 'Bericht',
    },
    planning: {
      acceptAll: 'Alle akzeptieren',
      actions: 'Aktionen',
      date: 'Datum',
      loadingOrders: 'Aufträge werden geladen...',
      noTruck: 'Dieser Spediteur hat noch keinen LKW.',
      ordersForTruck: 'Aufträge für LKW mit Kennzeichen {{licensePlate}}',
      planning: 'Planung',
      truck: 'LKW',
      managePlanning: 'Anzeigen und verwalten Sie Ihre Transportplanung',
    },
    selfBilling: {
      selfBilling: 'Self Billing',
      rideOverview: 'Fahrtenübersicht',
      manageRideOverview: 'Fahrtenübersichten anzeigen und herunterladen',
      searchRideOverviewPlaceholder: 'Fahrtenübersicht suchen...',
      type: 'Typ',
      number: 'Nummer',
      manageSelfBilling: 'Anzeigen und herunterladen Sie Ihr Self Billing',
      searchPlaceholder: 'Self Billing suchen...',
      id: 'Referenz',
      date: 'Datum',
      download: 'Herunterladen',
      invoice: 'Rechnung',
      title: 'Self Billing Rechnung',
    },
    generalInformation: {
      generalInformation: 'Informationen',
      noDocumentsAvailable: 'Keine Dokumente verfügbar',
      checkBackLater: 'Schauen Sie später nach aktualisierten Dokumenten',
    },

    businessInformation: {
      businessInformation: 'Geschäftsinformationen',
      settingsAndBusinessInformation: 'Einstellungen und Geschäftsinformationen',
      tabGeneral: 'Allgemein',
      tabFleet: 'Fuhrpark',
      tabContacts: 'Kontakte',
      civilLiabilityInsurance: 'Haftpflichtversicherung',
      CMRInsurance: 'CMR-Versicherung',
      transportationInsurance: 'Transportversicherung',
      documentUploaded: 'Dokument hochgeladen',
      insurances: 'Versicherungen',
    },
    contacts: {
      contacts: 'Kontakte',
      newContact: 'Neuer Kontakt',
      updateContact: 'Kontakt aktualisieren',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      function: 'Funktion',
      language: 'Sprache',
      delete: 'Löschen',
      createContactSuccess: 'Kontakt erfolgreich erstellt',
      createContactError: 'Fehler beim Erstellen des Kontakts: {{error}}',
      updateContactSuccess: 'Kontakt erfolgreich aktualisiert',
      updateContactError: 'Fehler beim Aktualisieren des Kontakts: {{error}}',
      deleteContact: 'Kontakt löschen',
      deleteContactConfirmation: 'Sind Sie sicher, dass Sie den Kontakt löschen möchten?',
      deleteContactSuccess: 'Kontakt erfolgreich gelöscht',
      deleteContactError: 'Fehler beim Löschen des Kontakts: {{error}}',
      notFound: 'Kontakt nicht gefunden',
      notifications: 'Benachrichtigungen',
    },
    trucks: {
      title: 'LKWs',
      newTruck: 'Neuer LKW',
      update: 'LKW aktualisieren',
      licensePlate: 'Kennzeichen',
      codeName: 'Codename',
      planner: 'Planer',
      isActive: 'Aktiv',
      insuranceExpiresAt: 'Versicherung läuft ab am',
      examinationExpiresAt: 'Untersuchung läuft ab am',
      documents: 'Dokumente',
      yes: 'Ja',
      no: 'Nein',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      create: 'Erstellen',
      succeeded: 'LKW gespeichert',
      createError: 'LKW konnte nicht erstellt werden: ',
      updateError: 'LKW konnte nicht aktualisiert werden: ',
      insurance: 'Versicherung',
      insuranceUploaded: 'Versicherung gespeichert',
      examination: 'Untersuchung',
      examinationUploaded: 'Untersuchung gespeichert',
      notFound: 'Keine LKWs gefunden',
      appLoginTitle: 'Fahrer-App Login',
      appLoginHint:
        'Fahrer melden sich mit dem Kennzeichen an. Passwort hier setzen; Fahrer können es nicht selbst zurücksetzen.',
      appPasswordLabel: 'Fahrer-App Passwort',
      appLoginLabel: 'Login (Kennzeichen)',
      appCodeNameLabel: 'Codename',
      appSavePassword: 'Passwort speichern',
      appDisableLogin: 'Login deaktivieren',
      appPasswordSaved: 'Passwort gespeichert',
      appLoginDisabled: 'Fahrer-App Login deaktiviert',
      detailsTitle: 'Zugmaschinendaten',
      documentCount: '{{count}} von {{total}}',
      statusValid: 'Gültig',
      statusExpiringSoon: 'Läuft bald ab',
      statusExpired: 'Abgelaufen',
      statusMissing: 'Fehlt',
      expiresOn: 'Läuft ab am {{date}}',
      noDocument: 'Noch kein Dokument hochgeladen',
      viewDocument: 'Ansehen',
      replaceDocument: 'Ersetzen',
      uploadDocument: 'Hochladen',
      searchPlaceholder: 'Nach Kennzeichen suchen…',
      noExpiryKnown: 'Kein Ablaufdatum bekannt',
      notUploadedYet: 'Noch nicht hochgeladen',
    },
    trailers: {
      title: 'Anhänger',
      truckAmount: 'Anzahl LKWs',
      tautlinerAmount: 'Anzahl Tautliner',
      boxTrailerAmount: 'Anzahl Box/Kühlanhänger',
      openTrailerAmount: 'Anzahl offene Anhänger',
      save: 'Änderungen speichern',
      saveSuccess: 'Spediteur aktualisiert',
      saveError: 'Spediteur konnte nicht aktualisiert werden: {{error}}',
      subtitle: 'Anzahl je Typ — für die Kapazitätsplanung',
    },
    invite: {
      title: 'Einladung zum Carrier Portal',
      details:
        'Sie wurden zum Carrier Portal von TransDirect eingeladen, erstellen Sie Ihr Konto, indem Sie Ihr Passwort eingeben.',
      accepted: 'Einladung wurde angenommen, Sie werden in Kürze zur Startseite weitergeleitet.',
      acceptError: 'Einladung konnte nicht angenommen werden: {{error}}',
      acceptButtonText: 'Einladung annehmen',
      password: 'Passwort',
      repeatPassword: 'Passwort wiederholen',
    },
    users: {
      users: 'Benutzer',
      inviteUser: 'Benutzer einladen',
      invitedUsers: 'Eingeladene Benutzer',
      noInvitedUsers: 'Keine eingeladenen Benutzer',
      removeInvite: 'Einladung entfernen',
      confirmRemoveInvite: 'Sind Sie sicher, dass Sie die Einladung für {{email}} entfernen möchten?',
      inviteRemoved: 'Einladung entfernt',
      couldNotRemoveInvite: 'Einladung konnte nicht entfernt werden: {{error}}',
      noUsersFound: 'Keine Benutzer gefunden',
      removeUser: 'Benutzer entfernen',
      confirmRemoveUser: 'Sind Sie sicher, dass Sie den Benutzer {{name}} entfernen möchten?',
      userRemoved: 'Benutzer entfernt',
      couldNotRemoveUser: 'Benutzer konnte nicht entfernt werden: {{error}}',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      userInvited: 'Benutzer eingeladen',
      couldNotInviteUser: 'Benutzer konnte nicht eingeladen werden: {{error}}',
      name: 'Name',
      email: 'E-Mail',
      isActive: 'Ist aktiv?',
      role: 'Rolle',
      roleDispatcher: 'Disponent',
      roleDriver: 'Fahrer',
      activeUsers: 'Aktive Benutzer',
      pendingInvitations: 'Ausstehende Einladungen',
      sendInvitation: 'Einladung senden',
      sending: 'Wird gesendet...',
      cancel: 'Abbrechen',
      emailAddress: 'E-Mail-Adresse',
      deleteInvitation: 'Einladung löschen',
      joined: 'Beigetreten',
      invited: 'Eingeladen',
      assignee: 'Zugewiesen an',
      assignOrder: 'Auftrag zuweisen',
      unassigned: 'Nicht zugewiesen',
      assignedTo: 'Zugewiesen an',
      roleUpdated: 'Rolle aktualisiert',
      renameUser: 'Benutzer umbenennen',
      newName: 'Neuer Name',
      userRenamed: 'Benutzer umbenannt',
      save: 'Speichern',
      permissions: 'Berechtigungen',
      canRenameUsers: 'Kann Benutzer umbenennen',
      permissionsUpdated: 'Berechtigungen aktualisiert',
      nameOptional: 'Name (optional)',
      emailRequired: 'Bitte geben Sie eine E-Mail-Adresse ein',
      namePlaceholder: 'Max Mustermann',
      emailPlaceholder: 'benutzer@beispiel.com',
    },
    tracking: {
      loading: 'Tracking-Ereignisse werden geladen...',
      events: 'Tracking Events',
      noEvents: 'Keine Tracking-Events gefunden',
      scheduled: 'Geplant',
      eventTypes: {
        StatusLoaded: 'Geladen',
        StatusUnloaded: 'Entladen',
        LocationPing: 'Standort-Update',
      },
      stop: 'Stopp',
      by: 'von',
    },
    driverBlock: {
      title: 'Fahrer-Zugang',
      message: 'Bitte melden Sie sich in der Fahrer-App auf Ihrem Handy an, um Ihre Aufträge einzusehen.',
    },
    notFound: {
      pageNotFound: 'Seite nicht gefunden.',
      pageNotFoundDesc:
        'Diese Seite scheint (noch) nicht zu existieren. Wenn Sie denken, dass etwas nicht stimmt, kontaktieren Sie bitte Ihren TransDirect-Ansprechpartner.',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Transportaufträge',
    selfBillings: 'Self Billings',
  },
  orderStatus: {
    Draft: 'Entwurf',
    Created: 'Erstellt',
    Prepayment: 'Vorauszahlung',
    Placed: 'Platziert',
    Confirmed: 'Bestätigt',
    Refused: 'Abgelehnt',
    Executed: 'Ausgeführt',
    Cancelled: 'Storniert',
  },
  orderSaleStatus: {
    Created: 'Erstellt',
    Credited: 'Gutschrift erteilt',
    Incomplete: 'Unvollständig',
    Invoiced: 'In Rechnung gestellt',
  },
  customerContactNotifications: {
    invoice: 'Rechnung',
    orderConfirmation: 'Auftragsbestätigung',
    cmr: 'CMR',
    quotation: 'Angebot',
    dieselSurcharge: 'Dieselzuschlag',
    paymentReminder: 'Zahlungserinnerung',
  },
  errors: {
    required: 'Erforderlich',
    invalidEmail: 'Ungültige E-Mail',
    dateShouldBeInTheFuture: 'Datum sollte in der Zukunft liegen',
    startTimeShouldBeBeforeEndTime: 'Startzeit sollte vor der Endzeit liegen',
    passwordsDontMatch: 'Passwort und Passwortwiederholung stimmen nicht überein.',
    passwordTooShort: 'Das Passwort ist zu kurz.',
    formValidation: 'Bitte überprüfen Sie die markierten Felder im Formular',
    retry: 'Erneut versuchen',
    reloadPage: 'Seite neu laden',
    networkTitle: 'Verbindungsproblem',
    networkDescription:
      'Wir können den Server nicht erreichen. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    serverTitle: 'Serverfehler',
    serverDescription: 'Der Server konnte Ihre Anfrage nicht verarbeiten. Bitte versuchen Sie es später erneut.',
    notFoundTitle: 'Nicht gefunden',
    notFoundDescription: 'Die angeforderten Daten existieren nicht mehr oder sind nicht verfügbar.',
    sessionTitle: 'Sitzung abgelaufen',
    sessionDescription: 'Ihre Sitzung ist abgelaufen oder Sie sind nicht angemeldet. Melden Sie sich erneut an.',
    permissionTitle: 'Kein Zugriff',
    permissionDescription: 'Sie haben keinen Zugriff auf diese Daten.',
    validationTitle: 'Ungültige Daten',
    validationDescription: 'Bitte prüfen Sie die eingegebenen Daten und versuchen Sie es erneut.',
    rateLimitTitle: 'Zu viele Anfragen',
    rateLimitDescription: 'Es wurden zu viele Anfragen gesendet. Warten Sie kurz und versuchen Sie es erneut.',
    abortedTitle: 'Anfrage abgebrochen',
    abortedDescription: 'Die Anfrage wurde abgebrochen. Versuchen Sie es bei Bedarf erneut.',
    unknownTitle: 'Unbekannter Fehler',
    unknownDescription:
      'Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut oder kontaktieren Sie den Support, wenn es weiterhin passiert.',
    loadingTitle: 'Laden fehlgeschlagen',
    loadingDescription: 'Die Daten konnten nicht geladen werden.',
  },
  orderComplaintType: {
    Aggression: 'Körperliche/Verbale Aggression',
    DamagedGoods: 'Beschädigte Ware',
    IncorrectDelivery: 'Falsche Lieferung',
    IncorrectInvoice: 'Falsche Rechnung',
    LateDelivery: 'Verspätete Lieferung',
    Other: 'Andere',
  },
  myProfile: {
    myProfile: 'Mein Profil',
    logout: 'Abmelden',
    name: 'Name',
    role: 'Rolle',
    email: 'E-Mail',
    language: 'Sprache',
    languageChanged: 'Sprache aktualisiert',
    languageNotChanged: 'Sprache konnte nicht aktualisiert werden: {{error}}',
    joinedAt: 'Beigetreten am',
    nameChanged: 'Name wurde aktualisiert',
    nameNotChanged: 'Name konnte nicht aktualisiert werden: {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Passwort vergessen',
      requestNewPassword: 'Neues Passwort anfordern',
      instructions:
        'Geben Sie Ihre E-Mail-Adresse ein, wenn der Benutzer im System existiert, erhalten Sie in Kürze eine E-Mail, um ein neues Passwort einzurichten.',
      requestFailed: 'Konnte kein neues Passwort anfordern',
      instructionsSent: 'Anweisungen zum Einrichten eines neuen Passworts wurden an Ihre E-Mail-Adresse gesendet.',
    },
    configNewPassword: {
      title: 'Neues Passwort festlegen',
      newPassword: 'Neues Passwort',
      repeatNewPassword: 'Neues Passwort wiederholen',
      confirmButtonText: 'Neues Passwort festlegen',
      passwordDontMatch: 'Passwort und wiederholtes Passwort müssen übereinstimmen',
      tokenNotFound: 'Token nicht gefunden',
      invalidToken: 'Token ist nicht mehr gültig',
      configFailed: 'Konnte Passwort nicht festlegen: {{error}}',
    },
    login: {
      login: 'Login',
      email: 'E-Mail',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen',
      customerLoginTitle: 'Kunden Login',
      loginWithGoogle: 'Mit Google anmelden',
      incorrectCredentials: 'E-Mail oder Passwort ist falsch',
      loginFailed: 'Anmeldung fehlgeschlagen: {{error}}',
    },
    userNotFound: {
      title: 'Benutzer nicht gefunden',
      description: 'Anmeldung fehlgeschlagen, ein Fehler ist aufgetreten oder der Benutzer existiert nicht mehr.',
      goToLoginPage: 'Zur Anmeldeseite gehen',
    },
  },
  upload: {
    title: 'Hochladen',
    dropzoneHint: 'Klicken Sie hier oder ziehen Sie Datei(en) in das Feld, um Datei(en) hochzuladen',
    uploadDocuments: 'Dokumente hochladen',
    confirmDeleteDocument: 'Sind Sie sicher, dass Sie dieses Dokument löschen möchten?',
    deleteDocument: 'Dokument löschen',
    noDocumentsFound: 'Keine Dokumente gefunden',
    noDocumentsSelected: 'Keine Dokumente ausgewählt',
    uploadFailed: 'Dokument konnte nicht hochgeladen werden',
    uploadDocumentFailed: 'Datei {{filename}} konnte nicht hochgeladen werden: {{reason}}',
    multiUploadFailed: 'Dateien konnten nicht hochgeladen werden: {{reason}}',
  },
  or: 'oder',
  draft: 'Entwurf',
  cancel: 'Abbrechen',
  close: 'Schließen',
  moreInfo: 'Mehr Info',
  previous: 'Vorherige',
  next: 'Nächste',
  delete: 'Löschen',
  save: 'Speichern',
  download: {
    open: 'Öffnen',
    download: 'Herunterladen',
    started: 'Download gestartet',
    failed: 'Download fehlgeschlagen: {{message}}',
  },
  chat: {
    title: 'Chat',
    sendMessage: 'Nachricht senden',
    placeholder: 'Nachricht eingeben...',
    noMessages: 'Noch keine Nachrichten',
    loadMore: 'Mehr Nachrichten laden',
    messageSent: 'Nachricht gesendet',
    messageError: 'Nachricht konnte nicht gesendet werden: {{error}}',
    newMessage: '{{name}}: neue Nachricht zur Bestellung {{orderNumber}}',
    internal: 'Intern',
    carrier: 'Spediteur',
  },
};
